export default "__VITE_ASSET__MfxySBIj__"